import React, { useState, useEffect, useRef } from 'react';
import './SimpleTimePickerSingle.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-solid-svg-icons';
import { apiFetch } from '../../utils/apiClient';

const SimpleTimePickerSingle = ({ selectedTime, handleTimeSelect, date }) => {

    // local development uses env.development, production routes to /api
    const API_URL = process.env.REACT_APP_API_URL || "/api";

    const selectRef = useRef(null);
    const [availableTimes, setAvailableTimes] = useState([]);

    useEffect(() => {
        const fetchFreeSlots = async () => {
            if (date) {
                try {

                    const meetingTimesURL = `${API_URL}/meetings/times/?date=${date.format('YYYY-MM-DD')}`;

                    const response = await apiFetch(meetingTimesURL); // Adjust the API endpoint if needed
                    if (!response.ok) {
                        console.error('Failed to fetch free slots:', response.status);
                        return;
                    }
                    const data = await response.json();
                    setAvailableTimes(data);
                } catch (error) {
                    console.error('Error fetching free slots:', error);
                }
            } else {
                setAvailableTimes([]); // Clear times if no date is selected
            }
        };

        fetchFreeSlots();
    }, [API_URL, date]); // Re-fetch when the date prop changes

    const handleTimeChange = (e) => {
        const newTime12Hour = e.target.value;
        handleTimeSelect(newTime12Hour);
    };

    return (
        <div className="simple-time-picker-wrapper">
            <div className="time-input-container">
                <select
                    ref={selectRef}
                    value={selectedTime}
                    onChange={handleTimeChange}
                    className="time-select-input"
                >
                    <option style={{ color: '#666' }} value="">Select Time</option>
                    {availableTimes.map(time12 => (
                        <option key={time12} value={time12}>{time12}</option>
                    ))}
                </select>
                <FontAwesomeIcon icon={faClock} className="time-icon-right" />
            </div>
        </div>
    );
};

export default SimpleTimePickerSingle;